export const COOKIE_CONSENT_BANNER = `cookiesBanner`
export const ANNOUNCEMENT_BANNER = `announcementBanner`
export const PRE_LAUNCH_BANNER = `preLaunchBanner`
